/* eslint-disable */

export const ganttData2 = {
  "gantt": {
    "zIndex": 0,
    "enabled": true,
    "type": "gantt-project",
    "title": {
      "zIndex": 80,
      "enabled": false,
      "fontSize": 16,
      "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
      "fontColor": "#7c868e",
      "fontOpacity": 1,
      "fontDecoration": "none",
      "fontStyle": "normal",
      "fontVariant": "normal",
      "fontWeight": "normal",
      "letterSpacing": "normal",
      "textDirection": "ltr",
      "lineHeight": "normal",
      "textIndent": 0,
      "vAlign": "top",
      "hAlign": "center",
      "wordWrap": "normal",
      "wordBreak": "normal",
      "textOverflow": "",
      "selectable": false,
      "disablePointerEvents": false,
      "useHtml": false,
      "width": null,
      "height": null,
      "align": "center",
      "text": "Chart Title",
      "margin": {
        "left": 0,
        "top": 0,
        "bottom": 0,
        "right": 0
      },
      "padding": {
        "left": 0,
        "top": 0,
        "bottom": 10,
        "right": 0
      },
      "background": {
        "zIndex": 0,
        "enabled": false
      }
    },
    "background": {
      "zIndex": 0.5,
      "enabled": true
    },
    "tooltip": {
      "enabled": true,
      "title": {
        "zIndex": 1,
        "enabled": true,
        "fontSize": 14,
        "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
        "fontColor": "#ffffff",
        "fontOpacity": 1,
        "fontDecoration": "none",
        "fontStyle": "normal",
        "fontVariant": "normal",
        "fontWeight": "normal",
        "letterSpacing": "normal",
        "textDirection": "ltr",
        "lineHeight": "normal",
        "textIndent": 0,
        "vAlign": "top",
        "hAlign": "left",
        "wordWrap": "normal",
        "wordBreak": "normal",
        "textOverflow": "",
        "selectable": false,
        "disablePointerEvents": false,
        "useHtml": false,
        "width": null,
        "height": null,
        "align": "left",
        "orientation": "top",
        "rotation": 0,
        "text": "",
        "margin": {
          "left": 0,
          "top": 0,
          "bottom": 0,
          "right": 0
        },
        "padding": {
          "left": 0,
          "top": 0,
          "bottom": 0,
          "right": 0
        },
        "background": {
          "enabled": false
        }
      },
      "separator": {
        "zIndex": 1,
        "enabled": true,
        "fill": {
          "color": "#CECECE",
          "opacity": 0.3
        },
        "stroke": "none",
        "width": "100%",
        "height": 1,
        "orientation": "top",
        "margin": {
          "left": 0,
          "top": 5,
          "bottom": 5,
          "right": 0
        }
      },
      "background": {
        "zIndex": 0,
        "enabled": true
      }
    },
    "margin": {
      "left": 0,
      "top": 0,
      "bottom": 0,
      "right": 0
    },
    "padding": {
      "left": 0,
      "top": 0,
      "bottom": 0,
      "right": 0
    },
    "a11y": {
      "enabled": true,
      "mode": "chart-elements"
    },
    "autoRedraw": true,
    "bounds": {},
    "contextMenu": {
      "enabled": true
    },
    "credits": {
      "text": "AnyChart",
      "url": "https://www.anychart.com/?utm_source=registered",
      "alt": "AnyChart - JavaScript Charts designed to be embedded and integrated{{anychart-version}}",
      "imgAlt": "AnyChart - JavaScript Charts",
      "logoSrc": "https://static.anychart.com/logo.png",
      "enabled": false
    },
    "selectRectangleMarqueeFill": {
      "color": "#d3d3d3",
      "opacity": 0.4
    },
    "selectRectangleMarqueeStroke": "#d3d3d3",
    "interactivity": {
      "spotRadius": 2,
      "multiSelectOnClick": false,
      "unselectOnClickOutOfPoint": true,
      "hoverMode": "single",
      "selectionMode": "multi-select"
    },
    "splitterPosition": 329,
    "defaultRowHeight": 60,
    "controller": {
      "isResourceChart": false,
      "treeData": {
        "rootMapping": {},
        "children": [
          {
            "treeDataItemData": {
              "id": 1,
              "name": "Hardware"
            },
            "treeDataItemMeta": {},
            "children": [
              {
                "treeDataItemData": {
                  "id": 4,
                  "optimisticStart": 1535760000000,
                  "optimisticEnd": 1537488000000,
                  "pessimisticStart": 1535760000000,
                  "pessimisticEnd": 1538179200000,
                  "mostLikelyStart": 1535760000000,
                  "mostLikelyEnd": 1537833600000,
                  "progressValue": 1,
                  "connectTo": 5,
                  "name": "Formalize Specs"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 5,
                  "optimisticStart": 1537488000000,
                  "optimisticEnd": 1539561600000,
                  "pessimisticStart": 1538179200000,
                  "pessimisticEnd": 1540771200000,
                  "mostLikelyStart": 1537833600000,
                  "mostLikelyEnd": 1540166400000,
                  "progressValue": 1,
                  "connectTo": 8,
                  "name": "Design Hardware"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 8,
                  "optimisticStart": 1539561600000,
                  "optimisticEnd": 1542153600000,
                  "pessimisticStart": 1540771200000,
                  "pessimisticEnd": 1543708800000,
                  "mostLikelyStart": 1540166400000,
                  "mostLikelyEnd": 1543017600000,
                  "progressValue": 1,
                  "connectTo": 10,
                  "name": "Breadboard Hardware"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 10,
                  "optimisticStart": 1542153600000,
                  "optimisticEnd": 1544572800000,
                  "pessimisticStart": 1543708800000,
                  "pessimisticEnd": 1546646400000,
                  "mostLikelyStart": 1543017600000,
                  "mostLikelyEnd": 1545782400000,
                  "progressValue": 1,
                  "connectTo": 11,
                  "name": "Test hardware"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 11,
                  "optimisticStart": 1544572800000,
                  "optimisticEnd": 1546473600000,
                  "pessimisticStart": 1546646400000,
                  "pessimisticEnd": 1549065600000,
                  "mostLikelyStart": 1545782400000,
                  "mostLikelyEnd": 1547856000000,
                  "progressValue": 0.6,
                  "connectTo": 14,
                  "name": "Release Hardware"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 14,
                  "optimisticStart": 1546473600000,
                  "optimisticEnd": 1549152000000,
                  "pessimisticStart": 1549065600000,
                  "pessimisticEnd": 1551830400000,
                  "mostLikelyStart": 1547856000000,
                  "mostLikelyEnd": 1550707200000,
                  "name": "Manufacture Hardware"
                },
                "treeDataItemMeta": {}
              }
            ]
          },
          {
            "treeDataItemData": {
              "id": 2,
              "name": "Software"
            },
            "treeDataItemMeta": {},
            "children": [
              {
                "treeDataItemData": {
                  "id": 7,
                  "optimisticStart": 1537488000000,
                  "optimisticEnd": 1540857600000,
                  "pessimisticStart": 1538179200000,
                  "pessimisticEnd": 1542672000000,
                  "mostLikelyStart": 1537833600000,
                  "mostLikelyEnd": 1541980800000,
                  "progressValue": 1,
                  "connectTo": 12,
                  "name": "Design Software"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 12,
                  "optimisticStart": 1540857600000,
                  "optimisticEnd": 1543881600000,
                  "pessimisticStart": 1542672000000,
                  "pessimisticEnd": 1546300800000,
                  "mostLikelyStart": 1542067200000,
                  "mostLikelyEnd": 1545264000000,
                  "progressValue": 0.8,
                  "connectTo": 15,
                  "name": "Complete Software"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 15,
                  "optimisticStart": 1543881600000,
                  "optimisticEnd": 1545782400000,
                  "pessimisticStart": 1546300800000,
                  "pessimisticEnd": 1548374400000,
                  "mostLikelyStart": 1545264000000,
                  "mostLikelyEnd": 1547251200000,
                  "name": "Release Software"
                },
                "treeDataItemMeta": {}
              }
            ]
          },
          {
            "treeDataItemData": {
              "id": 3,
              "name": "Manual"
            },
            "treeDataItemMeta": {},
            "children": [
              {
                "treeDataItemData": {
                  "id": 6,
                  "optimisticStart": 1537488000000,
                  "optimisticEnd": 1539561600000,
                  "pessimisticStart": 1538179200000,
                  "pessimisticEnd": 1540425600000,
                  "mostLikelyStart": 1537833600000,
                  "mostLikelyEnd": 1539993600000,
                  "progressValue": 1,
                  "connectTo": 9,
                  "name": "Layout Manual"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 9,
                  "optimisticStart": 1539561600000,
                  "optimisticEnd": 1541980800000,
                  "pessimisticStart": 1540425600000,
                  "pessimisticEnd": 1543017600000,
                  "mostLikelyStart": 1539993600000,
                  "mostLikelyEnd": 1542499200000,
                  "progressValue": 1,
                  "connectTo": 13,
                  "name": "Finish Manual"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 13,
                  "optimisticStart": 1541980800000,
                  "optimisticEnd": 1543536000000,
                  "pessimisticStart": 1542931200000,
                  "pessimisticEnd": 1544659200000,
                  "mostLikelyStart": 1542499200000,
                  "mostLikelyEnd": 1544140800000,
                  "progressValue": 0.5,
                  "connectTo": 16,
                  "name": "Release Manual"
                },
                "treeDataItemMeta": {}
              },
              {
                "treeDataItemData": {
                  "id": 16,
                  "optimisticStart": 1543536000000,
                  "optimisticEnd": 1544832000000,
                  "pessimisticStart": 1544659200000,
                  "pessimisticEnd": 1546128000000,
                  "mostLikelyStart": 1544140800000,
                  "mostLikelyEnd": 1545523200000,
                  "name": "Print Manuals"
                },
                "treeDataItemMeta": {}
              }
            ]
          }
        ],
        "index": [
          "id"
        ],
        "mapping": {
          "actualStart": "mostLikelyStart",
          "actualEnd": "mostLikelyEnd"
        }
      },
      "verticalOffset": 0,
      "startIndex": 0,
      "scrollTo": 0
    },
    "dataGrid": {
      "zIndex": 5,
      "enabled": true,
      "isStandalone": false,
      "headerHeight": 70,
      "edit": {},
      "horizontalOffset": 0,
      "buttons": {
        "enabled": true,
        "cursor": "pointer",
        "width": 15,
        "height": 15,
        "normal": {
          "content": "▸",
          "minFontSize": 8,
          "maxFontSize": 72,
          "adjustFontSize": {
            "width": false,
            "height": false
          },
          "fontSize": 12,
          "fontColor": "#7c868e",
          "vAlign": "middle",
          "hAlign": "center",
          "selectable": false,
          "disablePointerEvents": true,
          "background": {
            "enabled": true,
            "fill": {
              "color": "#fff",
              "opacity": 0.00001
            },
            "stroke": "none"
          }
        },
        "hovered": {
          "background": {}
        },
        "selected": {
          "content": "▾",
          "background": {}
        },
        "padding": {}
      },
      "columns": [
        {
          "enabled": true,
          "labels": {},
          "title": {
            "enabled": true,
            "fontSize": 16,
            "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
            "fontColor": "#7c868e",
            "fontOpacity": 1,
            "fontDecoration": "none",
            "fontStyle": "normal",
            "fontVariant": "normal",
            "fontWeight": "normal",
            "letterSpacing": "normal",
            "textDirection": "ltr",
            "lineHeight": "normal",
            "textIndent": 0,
            "vAlign": "middle",
            "hAlign": "center",
            "wordWrap": "normal",
            "wordBreak": "normal",
            "textOverflow": "",
            "selectable": false,
            "disablePointerEvents": false,
            "useHtml": false,
            "width": null,
            "height": 70,
            "align": "center",
            "text": "#",
            "margin": {
              "left": 0,
              "top": 0,
              "bottom": 0,
              "right": 0
            },
            "padding": {
              "left": 0,
              "top": 0,
              "bottom": 0,
              "right": 0
            },
            "background": {
              "enabled": false
            }
          }
        },
        {
          "enabled": true,
          "labels": {},
          "title": {
            "enabled": true,
            "fontSize": 16,
            "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
            "fontColor": "#7c868e",
            "fontOpacity": 1,
            "fontDecoration": "none",
            "fontStyle": "normal",
            "fontVariant": "normal",
            "fontWeight": "normal",
            "letterSpacing": "normal",
            "textDirection": "ltr",
            "lineHeight": "normal",
            "textIndent": 0,
            "vAlign": "middle",
            "hAlign": "center",
            "wordWrap": "normal",
            "wordBreak": "normal",
            "textOverflow": "",
            "selectable": false,
            "disablePointerEvents": false,
            "useHtml": false,
            "width": null,
            "height": 70,
            "align": "center",
            "text": "Name",
            "margin": {
              "left": 0,
              "top": 0,
              "bottom": 0,
              "right": 0
            },
            "padding": {
              "left": 0,
              "top": 0,
              "bottom": 0,
              "right": 0
            },
            "background": {
              "enabled": false
            }
          }
        }
      ],
      "horizontalScrollBar": {
        "enabled": true,
        "backgroundStroke": {
          "color": "#d5d5d5",
          "opacity": 0.25
        },
        "backgroundFill": {
          "color": "#e0e0e0",
          "opacity": 0.25
        },
        "sliderFill": {
          "color": "#d5d5d5",
          "opacity": 0.25
        },
        "sliderStroke": {
          "color": "#656565",
          "opacity": 0.25
        },
        "mouseOverOpacity": 0.45,
        "mouseOutOpacity": 0.25,
        "buttonsVisible": false,
        "barSize": 10,
        "cornersRadius": 5
      },
      "tooltip": {
        "enabled": true,
        "useHtml": true,
        "title": {
          "zIndex": 1,
          "enabled": true,
          "fontSize": "14px",
          "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
          "fontColor": "#e5e5e5",
          "fontOpacity": 1,
          "fontDecoration": "none",
          "fontStyle": "normal",
          "fontVariant": "normal",
          "fontWeight": "normal",
          "letterSpacing": "normal",
          "textDirection": "ltr",
          "lineHeight": "normal",
          "textIndent": 0,
          "vAlign": "top",
          "hAlign": "left",
          "wordWrap": "normal",
          "wordBreak": "normal",
          "textOverflow": "",
          "selectable": false,
          "disablePointerEvents": false,
          "useHtml": false,
          "width": null,
          "height": null,
          "align": "left",
          "orientation": "top",
          "rotation": 0,
          "text": "",
          "margin": {
            "left": 0,
            "top": 0,
            "bottom": 0,
            "right": 0
          },
          "padding": {
            "left": 0,
            "top": 0,
            "bottom": 0,
            "right": 0
          },
          "background": {
            "enabled": false
          }
        },
        "separator": {
          "zIndex": 1,
          "enabled": true,
          "fill": {
            "color": "#CECECE",
            "opacity": 0.3
          },
          "stroke": "none",
          "width": "100%",
          "height": 1,
          "orientation": "top",
          "margin": {
            "left": 0,
            "top": 5,
            "bottom": 5,
            "right": 0
          }
        },
        "background": {
          "zIndex": 0,
          "enabled": true
        }
      }
    },
    "timeline": {
      "zIndex": 5,
      "enabled": true,
      "isStandalone": false,
      "headerHeight": 70,
      "edit": {},
      "scale": {
        "visibleMinimum": 1534564224000,
        "visibleMaximum": 1552949280000,
        "dataMinimum": 1535760000000,
        "dataMaximum": 1550707200000,
        "minimumGap": 0.08,
        "maximumGap": 0.15,
        "zoomLevels": [
          [
            {
              "unit": "minute",
              "count": 10
            },
            {
              "unit": "hour",
              "count": 1
            },
            {
              "unit": "day",
              "count": 1
            }
          ],
          [
            {
              "unit": "hour",
              "count": 2
            },
            {
              "unit": "day",
              "count": 1
            },
            {
              "unit": "month",
              "count": 1
            }
          ],
          [
            {
              "unit": "day",
              "count": 1
            },
            {
              "unit": "week",
              "count": 1
            },
            {
              "unit": "month",
              "count": 1
            }
          ],
          [
            {
              "unit": "month",
              "count": 1
            },
            {
              "unit": "quarter",
              "count": 1
            },
            {
              "unit": "year",
              "count": 1
            }
          ],
          [
            {
              "unit": "quarter",
              "count": 1
            },
            {
              "unit": "year",
              "count": 1
            },
            {
              "unit": "year",
              "count": 10
            }
          ]
        ]
      },
      "labels": {
        "zIndex": 40,
        "enabled": true
      },
      "markers": {
        "zIndex": 50,
        "enabled": null,
        "anchor": "center-top",
        "offsetX": 0,
        "offsetY": 0,
        "type": "star5",
        "rotation": 0,
        "size": 6
      },
      "header": {
        "zIndex": 80,
        "enabled": true,
        "stroke": "#cecece",
        "levels": [
          {
            "enabled": true,
            "height": null
          },
          {
            "enabled": true,
            "height": null
          },
          {
            "enabled": true,
            "height": null
          }
        ],
        "labels": {},
        "background": {
          "enabled": true
        }
      },
      "elements": {
        "labels": {
          "enabled": null
        },
        "rendering": {},
        "normal": {},
        "selected": {},
        "edit": {
          "thumbs": {},
          "connectorThumbs": {},
          "start": {
            "thumb": {},
            "connectorThumb": {}
          },
          "end": {
            "thumb": {},
            "connectorThumb": {}
          }
        },
        "tooltip": {
          "enabled": true,
          "useHtml": true,
          "title": {
            "zIndex": 1,
            "enabled": true,
            "fontSize": "14px",
            "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
            "fontColor": "#e5e5e5",
            "fontOpacity": 1,
            "fontDecoration": "none",
            "fontStyle": "normal",
            "fontVariant": "normal",
            "fontWeight": "normal",
            "letterSpacing": "normal",
            "textDirection": "ltr",
            "lineHeight": "normal",
            "textIndent": 0,
            "vAlign": "top",
            "hAlign": "left",
            "wordWrap": "normal",
            "wordBreak": "normal",
            "textOverflow": "",
            "selectable": false,
            "disablePointerEvents": false,
            "useHtml": false,
            "width": null,
            "height": null,
            "align": "left",
            "orientation": "top",
            "rotation": 0,
            "text": "",
            "margin": {
              "left": 0,
              "top": 0,
              "bottom": 0,
              "right": 0
            },
            "padding": {
              "left": 0,
              "top": 0,
              "bottom": 0,
              "right": 0
            },
            "background": {
              "enabled": false
            }
          },
          "separator": {
            "zIndex": 1,
            "enabled": true,
            "fill": {
              "color": "#CECECE",
              "opacity": 0.3
            },
            "stroke": "none",
            "width": "100%",
            "height": 1,
            "orientation": "top",
            "margin": {
              "left": 0,
              "top": 5,
              "bottom": 5,
              "right": 0
            }
          },
          "background": {
            "zIndex": 0,
            "enabled": true
          }
        }
      },
      "connectors": {
        "normal": {},
        "selected": {}
      },
      "tasks": {
        "labels": {
          "enabled": null
        },
        "rendering": {
          "shapes": [
            {
              "name": "pessimisticTask",
              "shapeType": "path",
              "disablePointerEvents": false
            },
            {
              "name": "mostLikelyTask",
              "shapeType": "path",
              "disablePointerEvents": false
            },
            {
              "name": "optimisticTask",
              "shapeType": "path",
              "disablePointerEvents": false
            }
          ]
        },
        "normal": {},
        "selected": {
          "fill": "#45738B"
        },
        "edit": {
          "thumbs": {},
          "connectorThumbs": {},
          "start": {
            "thumb": {},
            "connectorThumb": {}
          },
          "end": {
            "thumb": {},
            "connectorThumb": {}
          }
        },
        "progress": {
          "height": "15%",
          "labels": {
            "enabled": false
          },
          "rendering": {},
          "normal": {},
          "selected": {
            "fill": "#47B7F2",
            "stroke": {
              "color": "#666",
              "opacity": 0.6
            }
          },
          "edit": {
            "thumbs": {},
            "connectorThumbs": {},
            "start": {
              "thumb": {},
              "connectorThumb": {}
            },
            "end": {
              "thumb": {},
              "connectorThumb": {}
            }
          }
        }
      },
      "groupingTasks": {
        "labels": {
          "enabled": null,
          "padding": {
            "left": 0,
            "top": 0,
            "bottom": 5,
            "right": 0
          },
          "position": "center",
          "anchor": "center"
        },
        "rendering": {
          "shapes": [
            {
              "name": "mostLikelyTask",
              "shapeType": "path",
              "disablePointerEvents": false
            }
          ]
        },
        "normal": {},
        "selected": {},
        "edit": {
          "thumbs": {},
          "connectorThumbs": {},
          "start": {
            "thumb": {},
            "connectorThumb": {}
          },
          "end": {
            "thumb": {},
            "connectorThumb": {}
          }
        },
        "progress": {
          "height": "50%",
          "offset": "50%",
          "labels": {
            "enabled": false
          },
          "rendering": {},
          "normal": {
            "fill": {
              "color": "#0078CD",
              "opacity": 0.7
            }
          },
          "selected": {
            "fill": {
              "color": "#47B7F1",
              "opacity": 0.7
            }
          },
          "edit": {
            "thumbs": {},
            "connectorThumbs": {},
            "start": {
              "thumb": {},
              "connectorThumb": {}
            },
            "end": {
              "thumb": {},
              "connectorThumb": {}
            }
          }
        }
      },
      "baselines": {
        "labels": {
          "enabled": false
        },
        "rendering": {},
        "normal": {},
        "selected": {},
        "edit": {
          "thumbs": {},
          "connectorThumbs": {},
          "start": {
            "thumb": {},
            "connectorThumb": {}
          },
          "end": {
            "thumb": {},
            "connectorThumb": {}
          }
        }
      },
      "milestones": {
        "labels": {
          "enabled": null
        },
        "rendering": {},
        "normal": {},
        "selected": {},
        "edit": {
          "thumbs": {},
          "connectorThumbs": {},
          "start": {
            "thumb": {},
            "connectorThumb": {}
          },
          "end": {
            "thumb": {},
            "connectorThumb": {}
          }
        },
        "preview": {
          "labels": {
            "enabled": false
          },
          "rendering": {},
          "normal": {},
          "selected": {},
          "edit": {
            "thumbs": {},
            "connectorThumbs": {},
            "start": {
              "thumb": {},
              "connectorThumb": {}
            },
            "end": {
              "thumb": {},
              "connectorThumb": {}
            }
          }
        }
      },
      "horizontalScrollBar": {
        "enabled": true,
        "backgroundStroke": {
          "color": "#d5d5d5",
          "opacity": 0.25
        },
        "backgroundFill": {
          "color": "#e0e0e0",
          "opacity": 0.25
        },
        "sliderFill": {
          "color": "#d5d5d5",
          "opacity": 0.25
        },
        "sliderStroke": {
          "color": "#656565",
          "opacity": 0.25
        },
        "mouseOverOpacity": 0.45,
        "mouseOutOpacity": 0.25,
        "buttonsVisible": false,
        "barSize": 10,
        "cornersRadius": 5
      },
      "verticalScrollBar": {
        "zIndex": 20,
        "enabled": true,
        "backgroundStroke": {
          "color": "#d5d5d5",
          "opacity": 0.25
        },
        "backgroundFill": {
          "color": "#e0e0e0",
          "opacity": 0.25
        },
        "sliderFill": {
          "color": "#d5d5d5",
          "opacity": 0.25
        },
        "sliderStroke": {
          "color": "#656565",
          "opacity": 0.25
        },
        "mouseOverOpacity": 0.45,
        "mouseOutOpacity": 0.25,
        "buttonsVisible": false,
        "barSize": 10,
        "cornersRadius": 5
      }
    },
    "edit": {},
    "palette": {
      "type": "distinct",
      "items": [
        "#64b5f6",
        "#1976d2",
        "#ef6c00",
        "#ffd54f",
        "#455a64",
        "#96a6a6",
        "#dd2c00",
        "#00838f",
        "#00bfa5",
        "#ffa000"
      ]
    }
  }
}





export const ganttData = {
    "gantt": {
        "zIndex": 0,
        "enabled": true,
        "type": "gantt-project",
        "title": {
            "zIndex": 80,
            "enabled": false,
            "fontSize": 16,
            "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
            "fontColor": "#7c868e",
            "fontOpacity": 1,
            "fontDecoration": "none",
            "fontStyle": "normal",
            "fontVariant": "normal",
            "fontWeight": "normal",
            "letterSpacing": "normal",
            "textDirection": "ltr",
            "lineHeight": "normal",
            "textIndent": 0,
            "vAlign": "top",
            "hAlign": "center",
            "wordWrap": "normal",
            "wordBreak": "normal",
            "textOverflow": "",
            "selectable": false,
            "disablePointerEvents": false,
            "useHtml": false,
            "width": null,
            "height": null,
            "align": "center",
            "text": "Chart Title",
            "margin": {
                "left": 0,
                "top": 0,
                "bottom": 0,
                "right": 0
            },
            "padding": {
                "left": 0,
                "top": 0,
                "bottom": 10,
                "right": 0
            },
            "background": {
                "zIndex": 0,
                "enabled": false
            }
        },
        "background": {
            "zIndex": 0.5,
            "enabled": true
        },
        "tooltip": {
            "enabled": true,
            "title": {
                "zIndex": 1,
                "enabled": true,
                "fontSize": 14,
                "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                "fontColor": "#ffffff",
                "fontOpacity": 1,
                "fontDecoration": "none",
                "fontStyle": "normal",
                "fontVariant": "normal",
                "fontWeight": "normal",
                "letterSpacing": "normal",
                "textDirection": "ltr",
                "lineHeight": "normal",
                "textIndent": 0,
                "vAlign": "top",
                "hAlign": "left",
                "wordWrap": "normal",
                "wordBreak": "normal",
                "textOverflow": "",
                "selectable": false,
                "disablePointerEvents": false,
                "useHtml": false,
                "width": null,
                "height": null,
                "align": "left",
                "orientation": "top",
                "rotation": 0,
                "text": "",
                "margin": {
                    "left": 0,
                    "top": 0,
                    "bottom": 0,
                    "right": 0
                },
                "padding": {
                    "left": 0,
                    "top": 0,
                    "bottom": 0,
                    "right": 0
                },
                "background": {
                    "enabled": false
                }
            },
            "separator": {
                "zIndex": 1,
                "enabled": true,
                "fill": {
                    "color": "#CECECE",
                    "opacity": 0.3
                },
                "stroke": "none",
                "width": "100%",
                "height": 1,
                "orientation": "top",
                "margin": {
                    "left": 0,
                    "top": 5,
                    "bottom": 5,
                    "right": 0
                }
            },
            "background": {
                "zIndex": 0,
                "enabled": true
            }
        },
        "margin": {
            "left": 0,
            "top": 0,
            "bottom": 0,
            "right": 0
        },
        "padding": {
            "left": 0,
            "top": 0,
            "bottom": 0,
            "right": 0
        },
        "a11y": {
            "enabled": true,
            "mode": "chart-elements"
        },
        "autoRedraw": true,
        "bounds": {},
        "contextMenu": {
            "enabled": true
        },
        "credits": {
            "text": "AnyChart",
            "url": "https://www.anychart.com/?utm_source=registered",
            "alt": "AnyChart - JavaScript Charts designed to be embedded and integrated{{anychart-version}}",
            "imgAlt": "AnyChart - JavaScript Charts",
            "logoSrc": "https://static.anychart.com/logo.png",
            "enabled": false
        },
        "selectRectangleMarqueeFill": {
            "color": "#d3d3d3",
            "opacity": 0.4
        },
        "selectRectangleMarqueeStroke": "#d3d3d3",
        "interactivity": {
            "spotRadius": 2,
            "multiSelectOnClick": false,
            "unselectOnClickOutOfPoint": true,
            "hoverMode": "single",
            "selectionMode": "multi-select"
        },
        "splitterPosition": 370,
        "defaultRowHeight": 20,
        "controller": {
            "isResourceChart": false,
            "treeData": {
                "rootMapping": {},
                "children": [
                  {
                        "treeDataItemData": {
                            "id": "1",
                            "name": "Phase 1 - Strategic Plan",
                            "progressValue": "14%",
                            "actualStart": 951350400000,
                            "actualEnd": 954201600000
                        },
                        "treeDataItemMeta": {},
                        "children": [{
                                "treeDataItemData": {
                                    "id": "2",
                                    "name": "Self-Assessment",
                                    "progressValue": "25%",
                                    "actualStart": 951350400000,
                                    "actualEnd": 951955200000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "3",
                                            "name": "Define business vision",
                                            "progressValue": "0%",
                                            "actualStart": 951408000000,
                                            "actualEnd": 951440400000,
                                            "connectTo": "4",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "4",
                                            "name": "Identify available skills, information and support",
                                            "progressValue": "0%",
                                            "actualStart": 951494400000,
                                            "actualEnd": 951526800000,
                                            "connectTo": "5",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "5",
                                            "name": "Decide whether to proceed",
                                            "progressValue": "0%",
                                            "actualStart": 951753600000,
                                            "actualEnd": 951786000000,
                                            "connectTo": "7",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "6",
                                    "name": "Define the Opportunity",
                                    "progressValue": "27%",
                                    "actualStart": 951782400000,
                                    "actualEnd": 952992000000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "7",
                                            "name": "Research the market and competition",
                                            "progressValue": "0%",
                                            "actualStart": 951840000000,
                                            "actualEnd": 951872400000,
                                            "connectTo": "8",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "8",
                                            "name": "Interview owners of similar businesses",
                                            "progressValue": "60%",
                                            "actualStart": 951868800000,
                                            "actualEnd": 952473600000,
                                            "connectTo": "9",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "9",
                                            "name": "Identify needed resources",
                                            "progressValue": "0%",
                                            "actualStart": 952531200000,
                                            "actualEnd": 952650000000,
                                            "connectTo": "10",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "10",
                                            "name": "Identify operating cost elements",
                                            "progressValue": "0%",
                                            "actualStart": 952704000000,
                                            "actualEnd": 952995600000,
                                            "connectTo": "12",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "11",
                                    "name": "Evaluate Business Approach",
                                    "progressValue": "0%",
                                    "actualStart": 953049600000,
                                    "actualEnd": 953341200000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "12",
                                            "name": "Define new entity requirements",
                                            "progressValue": "0%",
                                            "actualStart": 953049600000,
                                            "actualEnd": 953082000000,
                                            "connectTo": "17",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "13",
                                            "name": "Identify on-going business purchase opportunities",
                                            "progressValue": "0%",
                                            "actualStart": 953136000000,
                                            "actualEnd": 953168400000,
                                            "connectTo": "14",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "14",
                                            "name": "Research franchise possibilities",
                                            "progressValue": "0%",
                                            "actualStart": 953222400000,
                                            "actualEnd": 953254800000,
                                            "connectTo": "15",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "15",
                                            "name": "Summarize business approach",
                                            "progressValue": "0%",
                                            "actualStart": 953308800000,
                                            "actualEnd": 953341200000,
                                            "connectTo": "21",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "16",
                                    "name": "Evaluate Potential Risks and Rewards",
                                    "progressValue": "0%",
                                    "actualStart": 953136000000,
                                    "actualEnd": 953946000000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "17",
                                            "name": "Assess market size and stability",
                                            "progressValue": "0%",
                                            "actualStart": 953136000000,
                                            "actualEnd": 953254800000,
                                            "connectTo": "18",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "18",
                                            "name": "Estimate the competition",
                                            "progressValue": "0%",
                                            "actualStart": 953308800000,
                                            "actualEnd": 953341200000,
                                            "connectTo": "19",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "19",
                                            "name": "Assess needed resource availability",
                                            "progressValue": "0%",
                                            "actualStart": 953740800000,
                                            "actualEnd": 953859600000,
                                            "connectTo": "20",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "20",
                                            "name": "Evaluate realistic initial market share",
                                            "progressValue": "0%",
                                            "actualStart": 953913600000,
                                            "actualEnd": 953946000000
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "21",
                                            "name": "Determine financial requirements",
                                            "progressValue": "0%",
                                            "actualStart": 953568000000,
                                            "actualEnd": 953686800000,
                                            "connectTo": "22",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "22",
                                            "name": "Review personal suitability",
                                            "progressValue": "0%",
                                            "actualStart": 953740800000,
                                            "actualEnd": 953773200000,
                                            "connectTo": "23",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "23",
                                            "name": "Evaluate initial profitability",
                                            "progressValue": "0%",
                                            "actualStart": 953827200000,
                                            "actualEnd": 953859600000,
                                            "connectTo": "24",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "24",
                                    "name": "Review and modify the strategic plan",
                                    "progressValue": "0%",
                                    "actualStart": 953913600000,
                                    "actualEnd": 954208800000,
                                    "connectTo": "25",
                                    "connectorType": "FinishStart"
                                },
                                "treeDataItemMeta": {}
                            },
                            {
                                "treeDataItemData": {
                                    "id": "25",
                                    "name": "Confirm decision to proceed",
                                    "progressValue": "0%",
                                    "actualStart": 954208800000,
                                    "actualEnd": 954208800000,
                                    "connectTo": "28",
                                    "connectorType": "FinishStart"
                                },
                                "treeDataItemMeta": {}
                            }
                        ]
                    },
                    {
                        "treeDataItemData": {
                            "id": "26",
                            "name": "Phase 2 - Define the Business Opportunity",
                            "progressValue": "19%",
                            "actualStart": 954201600000,
                            "actualEnd": 957312000000
                        },
                        "treeDataItemMeta": {},
                        "children": [{
                                "treeDataItemData": {
                                    "id": "27",
                                    "name": "Define the Market",
                                    "progressValue": "28%",
                                    "actualStart": 954201600000,
                                    "actualEnd": 955670400000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "28",
                                            "name": "Access available information",
                                            "progressValue": "0%",
                                            "actualStart": 954262800000,
                                            "actualEnd": 954295200000,
                                            "connectTo": "35",
                                            "connectorType": "StartStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "29",
                                            "name": "Create market analysis plan",
                                            "progressValue": "0%",
                                            "actualStart": 954349200000,
                                            "actualEnd": 954468000000
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "30",
                                            "name": "Implement market analysis plan",
                                            "progressValue": "40%",
                                            "actualStart": 954460800000,
                                            "actualEnd": 955065600000,
                                            "connectTo": "31",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "31",
                                            "name": "Identify competition",
                                            "progressValue": "60%",
                                            "actualStart": 955065600000,
                                            "actualEnd": 955411200000,
                                            "connectTo": "32",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "32",
                                            "name": "Summarize the market",
                                            "progressValue": "0%",
                                            "actualStart": 955472400000,
                                            "actualEnd": 955591200000,
                                            "connectTo": "33",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "33",
                                            "name": "Identify target market niche",
                                            "progressValue": "0%",
                                            "actualStart": 955645200000,
                                            "actualEnd": 955677600000,
                                            "connectTo": "35",
                                            "connectorType": "StartStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "34",
                                    "name": "Identify Needed Materials and Supplies",
                                    "progressValue": "0%",
                                    "actualStart": 955645200000,
                                    "actualEnd": 956368800000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "35",
                                            "name": "Select a business approach (from 'Evaluate Business Approach' above)",
                                            "progressValue": "0%",
                                            "actualStart": 955645200000,
                                            "actualEnd": 955764000000,
                                            "connectTo": "36",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "36",
                                            "name": "Identify management staff resources",
                                            "progressValue": "0%",
                                            "actualStart": 955990800000,
                                            "actualEnd": 956023200000,
                                            "connectTo": "37",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "37",
                                            "name": "Identify staffing requirements",
                                            "progressValue": "0%",
                                            "actualStart": 956077200000,
                                            "actualEnd": 956109600000,
                                            "connectTo": "38",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "38",
                                            "name": "Identify needed raw materials",
                                            "progressValue": "0%",
                                            "actualStart": 956163600000,
                                            "actualEnd": 956196000000,
                                            "connectTo": "39",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "39",
                                            "name": "Identify needed utilities",
                                            "progressValue": "0%",
                                            "actualStart": 956250000000,
                                            "actualEnd": 956282400000,
                                            "connectTo": "40",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "40",
                                            "name": "Summarize operating expenses and financial projections",
                                            "progressValue": "0%",
                                            "actualStart": 956336400000,
                                            "actualEnd": 956368800000,
                                            "connectTo": "42",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "41",
                                    "name": "Evaluate Potential Risks and Rewards",
                                    "progressValue": "17%",
                                    "actualStart": 956534400000,
                                    "actualEnd": 957225600000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "42",
                                            "name": "Assess market size and stability",
                                            "progressValue": "50%",
                                            "actualStart": 956534400000,
                                            "actualEnd": 956707200000,
                                            "connectTo": "43",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "43",
                                            "name": "Assess needed resources availability",
                                            "progressValue": "0%",
                                            "actualStart": 956768400000,
                                            "actualEnd": 956887200000,
                                            "connectTo": "44",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "44",
                                            "name": "Forecast financial returns",
                                            "progressValue": "0%",
                                            "actualStart": 956941200000,
                                            "actualEnd": 957232800000,
                                            "connectTo": "45",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "45",
                                    "name": "Review and modify the business opportunity",
                                    "progressValue": "0%",
                                    "actualStart": 957286800000,
                                    "actualEnd": 957319200000,
                                    "connectTo": "46",
                                    "connectorType": "FinishStart"
                                },
                                "treeDataItemMeta": {}
                            },
                            {
                                "treeDataItemData": {
                                    "id": "46",
                                    "name": "Confirm decision to proceed",
                                    "progressValue": "0%",
                                    "actualStart": 957319200000,
                                    "actualEnd": 957319200000,
                                    "connectTo": "49",
                                    "connectorType": "FinishStart"
                                },
                                "treeDataItemMeta": {}
                            }
                        ]
                    },
                    {
                        "treeDataItemData": {
                            "id": "47",
                            "name": "Phase 3 - Plan for Action",
                            "progressValue": "17%",
                            "actualStart": 957312000000,
                            "actualEnd": 959817600000
                        },
                        "treeDataItemMeta": {},
                        "children": [{
                            "treeDataItemData": {
                                "id": "48",
                                "name": "Develop Detailed 5-Year Business Plan",
                                "progressValue": "17%",
                                "actualStart": 957312000000,
                                "actualEnd": 959817600000
                            },
                            "treeDataItemMeta": {},
                            "children": [{
                                    "treeDataItemData": {
                                        "id": "49",
                                        "name": "Describe the vision and opportunity",
                                        "progressValue": "0%",
                                        "actualStart": 957373200000,
                                        "actualEnd": 957405600000,
                                        "connectTo": "50",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "50",
                                        "name": "List assumptions",
                                        "progressValue": "0%",
                                        "actualStart": 957459600000,
                                        "actualEnd": 957492000000,
                                        "connectTo": "51",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "51",
                                        "name": "Describe the market",
                                        "progressValue": "0%",
                                        "actualStart": 957546000000,
                                        "actualEnd": 957578400000,
                                        "connectTo": "52",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "52",
                                        "name": "Describe the new business",
                                        "progressValue": "0%",
                                        "actualStart": 957805200000,
                                        "actualEnd": 957837600000,
                                        "connectTo": "53",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "53",
                                        "name": "Describe strengths, weaknesses, assets and threats",
                                        "progressValue": "0%",
                                        "actualStart": 957891600000,
                                        "actualEnd": 957924000000,
                                        "connectTo": "54",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "54",
                                        "name": "Estimate sales volume during startup period",
                                        "progressValue": "0%",
                                        "actualStart": 957978000000,
                                        "actualEnd": 958010400000,
                                        "connectTo": "55",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "55",
                                        "name": "Forecast operating costs",
                                        "progressValue": "0%",
                                        "actualStart": 958064400000,
                                        "actualEnd": 958096800000,
                                        "connectTo": "56",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "56",
                                        "name": "Establish pricing strategy",
                                        "progressValue": "0%",
                                        "actualStart": 958150800000,
                                        "actualEnd": 958183200000,
                                        "connectTo": "57",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "57",
                                        "name": "Forecast revenue",
                                        "progressValue": "0%",
                                        "actualStart": 958410000000,
                                        "actualEnd": 958442400000,
                                        "connectTo": "58",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "58",
                                        "name": "X",
                                        "progressValue": "0%",
                                        "actualStart": 958496400000,
                                        "actualEnd": 958615200000,
                                        "connectTo": "59",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "59",
                                        "name": "Develop break-even analysis",
                                        "progressValue": "0%",
                                        "actualStart": 958669200000,
                                        "actualEnd": 958701600000,
                                        "connectTo": "60",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "60",
                                        "name": "Develop cash-flow projection",
                                        "progressValue": "0%",
                                        "actualStart": 958755600000,
                                        "actualEnd": 958788000000,
                                        "connectTo": "61",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "61",
                                        "name": "Identify licensing and permitting requirements",
                                        "progressValue": "0%",
                                        "actualStart": 959014800000,
                                        "actualEnd": 959047200000,
                                        "connectTo": "62",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "62",
                                        "name": "Develop startup plan",
                                        "progressValue": "100%",
                                        "actualStart": 959101200000,
                                        "actualEnd": 959220000000,
                                        "connectTo": "63",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "63",
                                        "name": "Develop sales and marketing strategy",
                                        "progressValue": "0%",
                                        "actualStart": 959274000000,
                                        "actualEnd": 959306400000,
                                        "connectTo": "64",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "64",
                                        "name": "Develop distribution structure",
                                        "progressValue": "0%",
                                        "actualStart": 959360400000,
                                        "actualEnd": 959392800000,
                                        "connectTo": "65",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "65",
                                        "name": "Describe risks and opportunities",
                                        "progressValue": "20%",
                                        "actualStart": 959558400000,
                                        "actualEnd": 959731200000,
                                        "connectTo": "66",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "66",
                                        "name": "Publish the business plan",
                                        "progressValue": "0%",
                                        "actualStart": 959792400000,
                                        "actualEnd": 959824800000,
                                        "connectTo": "67",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                },
                                {
                                    "treeDataItemData": {
                                        "id": "67",
                                        "name": "Confirm decision to proceed",
                                        "progressValue": "0%",
                                        "actualStart": 959824800000,
                                        "actualEnd": 959824800000,
                                        "connectTo": "69",
                                        "connectorType": "FinishStart"
                                    },
                                    "treeDataItemMeta": {}
                                }
                            ]
                        }]
                    },
                    {
                        "treeDataItemData": {
                            "id": "68",
                            "name": "Phase 4 - Proceed With Startup Plan",
                            "progressValue": "24%",
                            "actualStart": 959817600000,
                            "actualEnd": 967075200000
                        },
                        "treeDataItemMeta": {},
                        "children": [{
                                "treeDataItemData": {
                                    "id": "69",
                                    "name": "Choose a location",
                                    "progressValue": "36%",
                                    "actualStart": 959817600000,
                                    "actualEnd": 959904000000,
                                    "connectTo": "72",
                                    "connectorType": "FinishStart"
                                },
                                "treeDataItemMeta": {}
                            },
                            {
                                "treeDataItemData": {
                                    "id": "70",
                                    "name": "Establish Business Structure",
                                    "progressValue": "14%",
                                    "actualStart": 959904000000,
                                    "actualEnd": 963273600000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "71",
                                            "name": "Choose a Name",
                                            "progressValue": "33%",
                                            "actualStart": 959904000000,
                                            "actualEnd": 960249600000
                                        },
                                        "treeDataItemMeta": {},
                                        "children": [{
                                                "treeDataItemData": {
                                                    "id": "72",
                                                    "name": "Identify implications",
                                                    "progressValue": "40%",
                                                    "actualStart": 959904000000,
                                                    "actualEnd": 959990400000,
                                                    "connectTo": "73",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "73",
                                                    "name": "Research name availability",
                                                    "progressValue": "0%",
                                                    "actualStart": 960224400000,
                                                    "actualEnd": 960256800000,
                                                    "connectTo": "87",
                                                    "connectorType": "StartStart"
                                                },
                                                "treeDataItemMeta": {}
                                            }
                                        ]
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "74",
                                            "name": "Choose a Bank",
                                            "progressValue": "0%",
                                            "actualStart": 960310800000,
                                            "actualEnd": 960861600000
                                        },
                                        "treeDataItemMeta": {},
                                        "children": [{
                                                "treeDataItemData": {
                                                    "id": "75",
                                                    "name": "Establish accounts",
                                                    "progressValue": "0%",
                                                    "actualStart": 960310800000,
                                                    "actualEnd": 960602400000,
                                                    "connectTo": "77",
                                                    "connectorType": "StartStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "76",
                                                    "name": "Establish line of credit",
                                                    "progressValue": "0%",
                                                    "actualStart": 960829200000,
                                                    "actualEnd": 960861600000,
                                                    "connectTo": "77",
                                                    "connectorType": "StartStart"
                                                },
                                                "treeDataItemMeta": {}
                                            }
                                        ]
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "77",
                                            "name": "Choose legal representation",
                                            "progressValue": "0%",
                                            "actualStart": 960829200000,
                                            "actualEnd": 960861600000,
                                            "connectTo": "78",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "78",
                                            "name": "Select business tax-basis category",
                                            "progressValue": "0%",
                                            "actualStart": 960915600000,
                                            "actualEnd": 961034400000,
                                            "connectTo": "79",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "79",
                                            "name": "Choose capital funding source",
                                            "progressValue": "0%",
                                            "actualStart": 961088400000,
                                            "actualEnd": 961207200000,
                                            "connectTo": "98",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "80",
                                            "name": "Commit capital funding",
                                            "progressValue": "0%",
                                            "actualStart": 961207200000,
                                            "actualEnd": 961207200000,
                                            "connectTo": "82",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "81",
                                            "name": "Establish the Operating Control Base",
                                            "progressValue": "19%",
                                            "actualStart": 961372800000,
                                            "actualEnd": 963273600000
                                        },
                                        "treeDataItemMeta": {},
                                        "children": [{
                                                "treeDataItemData": {
                                                    "id": "82",
                                                    "name": "Choose and set up the accounting system",
                                                    "progressValue": "0%",
                                                    "actualStart": 961434000000,
                                                    "actualEnd": 961552800000,
                                                    "connectTo": "83",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "83",
                                                    "name": "Obtain required licenses and permits",
                                                    "progressValue": "38%",
                                                    "actualStart": 961545600000,
                                                    "actualEnd": 962409600000,
                                                    "connectTo": "84",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "84",
                                                    "name": "Obtain needed insurance",
                                                    "progressValue": "0%",
                                                    "actualStart": 962643600000,
                                                    "actualEnd": 962935200000,
                                                    "connectTo": "85",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "85",
                                                    "name": "Establish security plan",
                                                    "progressValue": "0%",
                                                    "actualStart": 962989200000,
                                                    "actualEnd": 963280800000,
                                                    "connectTo": "91",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            }
                                        ]
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "86",
                                            "name": "Develop Marketing Program",
                                            "progressValue": "0%",
                                            "actualStart": 960224400000,
                                            "actualEnd": 960516000000
                                        },
                                        "treeDataItemMeta": {},
                                        "children": [{
                                                "treeDataItemData": {
                                                    "id": "87",
                                                    "name": "Establish an advertising program",
                                                    "progressValue": "0%",
                                                    "actualStart": 960224400000,
                                                    "actualEnd": 960343200000,
                                                    "connectTo": "88",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "88",
                                                    "name": "Develop a logo",
                                                    "progressValue": "0%",
                                                    "actualStart": 960397200000,
                                                    "actualEnd": 960429600000,
                                                    "connectTo": "89",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            },
                                            {
                                                "treeDataItemData": {
                                                    "id": "89",
                                                    "name": "Order promotional materials",
                                                    "progressValue": "0%",
                                                    "actualStart": 960483600000,
                                                    "actualEnd": 960516000000,
                                                    "connectTo": "91",
                                                    "connectorType": "FinishStart"
                                                },
                                                "treeDataItemMeta": {}
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "90",
                                    "name": "Provide Physical Facilities",
                                    "progressValue": "16%",
                                    "actualStart": 963273600000,
                                    "actualEnd": 967075200000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "91",
                                            "name": "Secure operation space",
                                            "progressValue": "0%",
                                            "actualStart": 963334800000,
                                            "actualEnd": 963885600000,
                                            "connectTo": "92",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "92",
                                            "name": "Select computer network hardware",
                                            "progressValue": "100%",
                                            "actualStart": 963939600000,
                                            "actualEnd": 963972000000,
                                            "connectTo": "93",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "93",
                                            "name": "Select computer software",
                                            "progressValue": "0%",
                                            "actualStart": 964026000000,
                                            "actualEnd": 964058400000,
                                            "connectTo": "94",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "94",
                                            "name": "Establish utilities",
                                            "progressValue": "67%",
                                            "actualStart": 964137600000,
                                            "actualEnd": 964569600000,
                                            "connectTo": "95",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "95",
                                            "name": "Provide furniture and equipment",
                                            "progressValue": "15%",
                                            "actualStart": 964569600000,
                                            "actualEnd": 965088000000,
                                            "connectTo": "96",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "96",
                                            "name": "Move in",
                                            "progressValue": "13%",
                                            "actualStart": 966988800000,
                                            "actualEnd": 967075200000
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            },
                            {
                                "treeDataItemData": {
                                    "id": "97",
                                    "name": "Provide Staffing",
                                    "progressValue": "30%",
                                    "actualStart": 961372800000,
                                    "actualEnd": 966988800000
                                },
                                "treeDataItemMeta": {},
                                "children": [{
                                        "treeDataItemData": {
                                            "id": "98",
                                            "name": "Interview and test candidates",
                                            "progressValue": "43%",
                                            "actualStart": 961372800000,
                                            "actualEnd": 962928000000,
                                            "connectTo": "99",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "99",
                                            "name": "Hire staff",
                                            "progressValue": "10%",
                                            "actualStart": 962928000000,
                                            "actualEnd": 964137600000,
                                            "connectTo": "100",
                                            "connectorType": "FinishStart"
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "100",
                                            "name": "Train staff",
                                            "progressValue": "31%",
                                            "actualStart": 965088000000,
                                            "actualEnd": 966988800000
                                        },
                                        "treeDataItemMeta": {}
                                    },
                                    {
                                        "treeDataItemData": {
                                            "id": "102",
                                            "name": "Mau & Ago business",
                                            "progressValue": "40%",
                                            "actualStart": 951350400000,
                                            "actualEnd": 951955200000
                                        },
                                        "treeDataItemMeta": {}
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "index": [
                    "id"
                ]
            },
            "verticalOffset": 0,
            "startIndex": 0,
            "scrollTo": 0
        },
        "dataGrid": {
            "zIndex": 5,
            "enabled": true,
            "isStandalone": false,
            "headerHeight": 70,
            "edit": {},
            "horizontalOffset": 0,
            "buttons": {
                "enabled": true,
                "cursor": "pointer",
                "width": 15,
                "height": 15,
                "normal": {
                    "content": "▸",
                    "minFontSize": 8,
                    "maxFontSize": 72,
                    "adjustFontSize": {
                        "width": false,
                        "height": false
                    },
                    "fontSize": 12,
                    "fontColor": "#7c868e",
                    "vAlign": "middle",
                    "hAlign": "center",
                    "selectable": false,
                    "disablePointerEvents": true,
                    "background": {
                        "enabled": true,
                        "fill": {
                            "color": "#fff",
                            "opacity": 0.00001
                        },
                        "stroke": "none"
                    }
                },
                "hovered": {
                    "background": {}
                },
                "selected": {
                    "content": "▾",
                    "background": {}
                },
                "padding": {}
            },
            "columns": [{
                    "enabled": true,
                    "width": 30,
                    "labels": {
                        "hAlign": "center"
                    },
                    "title": {
                        "enabled": true,
                        "fontSize": 16,
                        "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                        "fontColor": "#7c868e",
                        "fontOpacity": 1,
                        "fontDecoration": "none",
                        "fontStyle": "normal",
                        "fontVariant": "normal",
                        "fontWeight": "normal",
                        "letterSpacing": "normal",
                        "textDirection": "ltr",
                        "lineHeight": "normal",
                        "textIndent": 0,
                        "vAlign": "middle",
                        "hAlign": "center",
                        "wordWrap": "normal",
                        "wordBreak": "normal",
                        "textOverflow": "",
                        "selectable": false,
                        "disablePointerEvents": false,
                        "useHtml": false,
                        "width": null,
                        "height": 70,
                        "align": "center",
                        "text": "#",
                        "margin": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "padding": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "background": {
                            "enabled": false
                        }
                    }
                },
                {
                    "enabled": true,
                    "labels": {
                        "hAlign": "left",
                        "width": 180
                    },
                    "title": {
                        "enabled": true,
                        "fontSize": 16,
                        "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                        "fontColor": "#7c868e",
                        "fontOpacity": 1,
                        "fontDecoration": "none",
                        "fontStyle": "normal",
                        "fontVariant": "normal",
                        "fontWeight": "normal",
                        "letterSpacing": "normal",
                        "textDirection": "ltr",
                        "lineHeight": "normal",
                        "textIndent": 0,
                        "vAlign": "middle",
                        "hAlign": "center",
                        "wordWrap": "normal",
                        "wordBreak": "normal",
                        "textOverflow": "",
                        "selectable": false,
                        "disablePointerEvents": false,
                        "useHtml": false,
                        "width": null,
                        "height": 70,
                        "align": "center",
                        "text": "Name",
                        "margin": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "padding": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "background": {
                            "enabled": false
                        }
                    }
                },
                {
                    "enabled": true,
                    "width": 70,
                    "labels": {
                        "hAlign": "right"
                    },
                    "title": {
                        "enabled": true,
                        "fontSize": 16,
                        "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                        "fontColor": "#7c868e",
                        "fontOpacity": 1,
                        "fontDecoration": "none",
                        "fontStyle": "normal",
                        "fontVariant": "normal",
                        "fontWeight": "normal",
                        "letterSpacing": "normal",
                        "textDirection": "ltr",
                        "lineHeight": "normal",
                        "textIndent": 0,
                        "vAlign": "middle",
                        "hAlign": "center",
                        "wordWrap": "normal",
                        "wordBreak": "normal",
                        "textOverflow": "",
                        "selectable": false,
                        "disablePointerEvents": false,
                        "useHtml": false,
                        "width": null,
                        "height": 70,
                        "align": "center",
                        "text": "Start Time",
                        "margin": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "padding": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "background": {
                            "enabled": false
                        }
                    }
                },
                {
                    "enabled": true,
                    "width": 80,
                    "labels": {
                        "hAlign": "right"
                    },
                    "title": {
                        "enabled": true,
                        "fontSize": 16,
                        "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                        "fontColor": "#7c868e",
                        "fontOpacity": 1,
                        "fontDecoration": "none",
                        "fontStyle": "normal",
                        "fontVariant": "normal",
                        "fontWeight": "normal",
                        "letterSpacing": "normal",
                        "textDirection": "ltr",
                        "lineHeight": "normal",
                        "textIndent": 0,
                        "vAlign": "middle",
                        "hAlign": "center",
                        "wordWrap": "normal",
                        "wordBreak": "normal",
                        "textOverflow": "",
                        "selectable": false,
                        "disablePointerEvents": false,
                        "useHtml": false,
                        "width": null,
                        "height": 70,
                        "align": "center",
                        "text": "End Time",
                        "margin": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "padding": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "background": {
                            "enabled": false
                        }
                    }
                }
            ],
            "horizontalScrollBar": {
                "enabled": true,
                "backgroundStroke": {
                    "color": "#d5d5d5",
                    "opacity": 0.25
                },
                "backgroundFill": {
                    "color": "#e0e0e0",
                    "opacity": 0.25
                },
                "sliderFill": {
                    "color": "#d5d5d5",
                    "opacity": 0.25
                },
                "sliderStroke": {
                    "color": "#656565",
                    "opacity": 0.25
                },
                "mouseOverOpacity": 0.45,
                "mouseOutOpacity": 0.25,
                "buttonsVisible": false,
                "barSize": 10,
                "cornersRadius": 5
            },
            "tooltip": {
                "enabled": true,
                "title": {
                    "zIndex": 1,
                    "enabled": true,
                    "fontSize": "14px",
                    "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                    "fontColor": "#e5e5e5",
                    "fontOpacity": 1,
                    "fontDecoration": "none",
                    "fontStyle": "normal",
                    "fontVariant": "normal",
                    "fontWeight": "normal",
                    "letterSpacing": "normal",
                    "textDirection": "ltr",
                    "lineHeight": "normal",
                    "textIndent": 0,
                    "vAlign": "top",
                    "hAlign": "left",
                    "wordWrap": "normal",
                    "wordBreak": "normal",
                    "textOverflow": "",
                    "selectable": false,
                    "disablePointerEvents": false,
                    "useHtml": false,
                    "width": null,
                    "height": null,
                    "align": "left",
                    "orientation": "top",
                    "rotation": 0,
                    "text": "",
                    "margin": {
                        "left": 0,
                        "top": 0,
                        "bottom": 0,
                        "right": 0
                    },
                    "padding": {
                        "left": 0,
                        "top": 0,
                        "bottom": 0,
                        "right": 0
                    },
                    "background": {
                        "enabled": false
                    }
                },
                "separator": {
                    "zIndex": 1,
                    "enabled": true,
                    "fill": {
                        "color": "#CECECE",
                        "opacity": 0.3
                    },
                    "stroke": "none",
                    "width": "100%",
                    "height": 1,
                    "orientation": "top",
                    "margin": {
                        "left": 0,
                        "top": 5,
                        "bottom": 5,
                        "right": 0
                    }
                },
                "background": {
                    "zIndex": 0,
                    "enabled": true
                }
            }
        },
        "timeline": {
            "zIndex": 5,
            "enabled": true,
            "isStandalone": false,
            "headerHeight": 70,
            "edit": {},
            "scale": {
                "visibleMinimum": 951350400000,
                "visibleMaximum": 954201600000,
                "dataMinimum": 951350400000,
                "dataMaximum": 967075200000,
                "minimumGap": 0.01,
                "maximumGap": 0.01,
                "zoomLevels": [
                    [{
                            "unit": "minute",
                            "count": 10
                        },
                        {
                            "unit": "hour",
                            "count": 1
                        },
                        {
                            "unit": "day",
                            "count": 1
                        }
                    ],
                    [{
                            "unit": "hour",
                            "count": 2
                        },
                        {
                            "unit": "day",
                            "count": 1
                        },
                        {
                            "unit": "month",
                            "count": 1
                        }
                    ],
                    [{
                            "unit": "day",
                            "count": 1
                        },
                        {
                            "unit": "week",
                            "count": 1
                        },
                        {
                            "unit": "month",
                            "count": 1
                        }
                    ],
                    [{
                            "unit": "month",
                            "count": 1
                        },
                        {
                            "unit": "quarter",
                            "count": 1
                        },
                        {
                            "unit": "year",
                            "count": 1
                        }
                    ],
                    [{
                            "unit": "quarter",
                            "count": 1
                        },
                        {
                            "unit": "year",
                            "count": 1
                        },
                        {
                            "unit": "year",
                            "count": 10
                        }
                    ]
                ]
            },
            "labels": {
                "zIndex": 40,
                "enabled": true
            },
            "markers": {
                "zIndex": 50,
                "enabled": null,
                "anchor": "center-top",
                "offsetX": 0,
                "offsetY": 0,
                "type": "star5",
                "rotation": 0,
                "size": 6
            },
            "header": {
                "zIndex": 80,
                "enabled": true,
                "stroke": "#cecece",
                "levels": [{
                        "enabled": true,
                        "height": null
                    },
                    {
                        "enabled": true,
                        "height": null
                    },
                    {
                        "enabled": true,
                        "height": null
                    }
                ],
                "labels": {},
                "background": {
                    "enabled": true
                }
            },
            "elements": {
                "labels": {
                    "enabled": null
                },
                "rendering": {},
                "normal": {},
                "selected": {},
                "edit": {
                    "thumbs": {},
                    "connectorThumbs": {},
                    "start": {
                        "thumb": {},
                        "connectorThumb": {}
                    },
                    "end": {
                        "thumb": {},
                        "connectorThumb": {}
                    }
                },
                "tooltip": {
                    "enabled": true,
                    "title": {
                        "zIndex": 1,
                        "enabled": true,
                        "fontSize": "14px",
                        "fontFamily": "Verdana, Helvetica, Arial, sans-serif",
                        "fontColor": "#e5e5e5",
                        "fontOpacity": 1,
                        "fontDecoration": "none",
                        "fontStyle": "normal",
                        "fontVariant": "normal",
                        "fontWeight": "normal",
                        "letterSpacing": "normal",
                        "textDirection": "ltr",
                        "lineHeight": "normal",
                        "textIndent": 0,
                        "vAlign": "top",
                        "hAlign": "left",
                        "wordWrap": "normal",
                        "wordBreak": "normal",
                        "textOverflow": "",
                        "selectable": false,
                        "disablePointerEvents": false,
                        "useHtml": false,
                        "width": null,
                        "height": null,
                        "align": "left",
                        "orientation": "top",
                        "rotation": 0,
                        "text": "",
                        "margin": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "padding": {
                            "left": 0,
                            "top": 0,
                            "bottom": 0,
                            "right": 0
                        },
                        "background": {
                            "enabled": false
                        }
                    },
                    "separator": {
                        "zIndex": 1,
                        "enabled": true,
                        "fill": {
                            "color": "#CECECE",
                            "opacity": 0.3
                        },
                        "stroke": "none",
                        "width": "100%",
                        "height": 1,
                        "orientation": "top",
                        "margin": {
                            "left": 0,
                            "top": 5,
                            "bottom": 5,
                            "right": 0
                        }
                    },
                    "background": {
                        "zIndex": 0,
                        "enabled": true
                    }
                }
            },
            "connectors": {
                "normal": {},
                "selected": {}
            },
            "tasks": {
                "labels": {
                    "enabled": null
                },
                "rendering": {},
                "normal": {},
                "selected": {},
                "edit": {
                    "thumbs": {},
                    "connectorThumbs": {},
                    "start": {
                        "thumb": {},
                        "connectorThumb": {}
                    },
                    "end": {
                        "thumb": {},
                        "connectorThumb": {}
                    }
                },
                "progress": {
                    "labels": {
                        "enabled": false
                    },
                    "rendering": {},
                    "normal": {},
                    "selected": {},
                    "edit": {
                        "thumbs": {},
                        "connectorThumbs": {},
                        "start": {
                            "thumb": {},
                            "connectorThumb": {}
                        },
                        "end": {
                            "thumb": {},
                            "connectorThumb": {}
                        }
                    }
                }
            },
            "groupingTasks": {
                "labels": {
                    "enabled": null
                },
                "rendering": {},
                "normal": {},
                "selected": {},
                "edit": {
                    "thumbs": {},
                    "connectorThumbs": {},
                    "start": {
                        "thumb": {},
                        "connectorThumb": {}
                    },
                    "end": {
                        "thumb": {},
                        "connectorThumb": {}
                    }
                },
                "progress": {
                    "labels": {
                        "enabled": false
                    },
                    "rendering": {},
                    "normal": {},
                    "selected": {},
                    "edit": {
                        "thumbs": {},
                        "connectorThumbs": {},
                        "start": {
                            "thumb": {},
                            "connectorThumb": {}
                        },
                        "end": {
                            "thumb": {},
                            "connectorThumb": {}
                        }
                    }
                }
            },
            "baselines": {
                "labels": {
                    "enabled": false
                },
                "rendering": {},
                "normal": {},
                "selected": {},
                "edit": {
                    "thumbs": {},
                    "connectorThumbs": {},
                    "start": {
                        "thumb": {},
                        "connectorThumb": {}
                    },
                    "end": {
                        "thumb": {},
                        "connectorThumb": {}
                    }
                }
            },
            "milestones": {
                "labels": {
                    "enabled": null
                },
                "rendering": {},
                "normal": {},
                "selected": {},
                "edit": {
                    "thumbs": {},
                    "connectorThumbs": {},
                    "start": {
                        "thumb": {},
                        "connectorThumb": {}
                    },
                    "end": {
                        "thumb": {},
                        "connectorThumb": {}
                    }
                },
                "preview": {
                    "labels": {
                        "enabled": false
                    },
                    "rendering": {},
                    "normal": {},
                    "selected": {},
                    "edit": {
                        "thumbs": {},
                        "connectorThumbs": {},
                        "start": {
                            "thumb": {},
                            "connectorThumb": {}
                        },
                        "end": {
                            "thumb": {},
                            "connectorThumb": {}
                        }
                    }
                }
            },
            "horizontalScrollBar": {
                "enabled": true,
                "backgroundStroke": {
                    "color": "#d5d5d5",
                    "opacity": 0.25
                },
                "backgroundFill": {
                    "color": "#e0e0e0",
                    "opacity": 0.25
                },
                "sliderFill": {
                    "color": "#d5d5d5",
                    "opacity": 0.25
                },
                "sliderStroke": {
                    "color": "#656565",
                    "opacity": 0.25
                },
                "mouseOverOpacity": 0.45,
                "mouseOutOpacity": 0.25,
                "buttonsVisible": false,
                "barSize": 10,
                "cornersRadius": 5
            },
            "verticalScrollBar": {
                "zIndex": 20,
                "enabled": true,
                "backgroundStroke": {
                    "color": "#d5d5d5",
                    "opacity": 0.25
                },
                "backgroundFill": {
                    "color": "#e0e0e0",
                    "opacity": 0.25
                },
                "sliderFill": {
                    "color": "#d5d5d5",
                    "opacity": 0.25
                },
                "sliderStroke": {
                    "color": "#656565",
                    "opacity": 0.25
                },
                "mouseOverOpacity": 0.45,
                "mouseOutOpacity": 0.25,
                "buttonsVisible": false,
                "barSize": 10,
                "cornersRadius": 5
            }
        },
        "edit": {},
        "palette": {
            "type": "distinct",
            "items": [
                "#64b5f6",
                "#1976d2",
                "#ef6c00",
                "#ffd54f",
                "#455a64",
                "#96a6a6",
                "#dd2c00",
                "#00838f",
                "#00bfa5",
                "#ffa000"
            ]
        }
    }
}




export const CombineData = {
    'chart': {
        'title': 'Combination of Column, Spline-Area and Spline Chart',
        'animation': true,
        'tooltip': {
            'displayMode': 'union'
        },
        'interactivity': {
            'hoverMode': 'by-x'
        },
        'series': [{
            'seriesType': 'column',
            'name': 'Column',
            'data': [{
                    'x': 'P1',
                    'value': 5854
                },
                {
                    'x': 'P2',
                    'value': 4171
                },
                {
                    'x': 'P3',
                    'value': 1375
                },
                {
                    'x': 'P4',
                    'value': 1875
                },
                {
                    'x': 'P5',
                    'value': 2246
                },
                {
                    'x': 'P6',
                    'value': 2696
                },
                {
                    'x': 'P7',
                    'value': 1287
                },
                {
                    'x': 'P8',
                    'value': 2140
                },
                {
                    'x': 'P9',
                    'value': 1603
                },
                {
                    'x': 'P10',
                    'value': 1628
                }
            ]
        }, {
            'seriesType': 'spline-area',
            'name': 'Spline',
            'legendItem': {
                'enabled': true,
                'iconType': 'square',
                'iconStroke': 'none'
            },
            'data': [{
                    'x': 'P1',
                    'value': 3242
                },
                {
                    'x': 'P2',
                    'value': 3171
                },
                {
                    'x': 'P3',
                    'value': 700
                },
                {
                    'x': 'P4',
                    'value': 1287
                },
                {
                    'x': 'P5',
                    'value': 1856
                },
                {
                    'x': 'P6',
                    'value': 1126
                },
                {
                    'x': 'P7',
                    'value': 987
                },
                {
                    'x': 'P8',
                    'value': 1610
                },
                {
                    'x': 'P9',
                    'value': 903
                },
                {
                    'x': 'P10',
                    'value': 928
                }
            ]
        }, {
            'seriesType': 'spline',
            'name': 'Line',
            'normal': {
                'stroke': {
                    'color': '#ef6c00',
                    'thickness': 2.5
                }
            },
            'data': [{
                    'x': 'P1',
                    'value': 1740
                },
                {
                    'x': 'P2',
                    'value': 1970
                },
                {
                    'x': 'P3',
                    'value': 1550
                },
                {
                    'x': 'P4',
                    'value': 1500
                },
                {
                    'x': 'P5',
                    'value': 6600
                },
                {
                    'x': 'P6',
                    'value': 8500
                },
                {
                    'x': 'P7',
                    'value': 3700
                },
                {
                    'x': 'P8',
                    'value': 1000
                },
                {
                    'x': 'P9',
                    'value': 4400
                },
                {
                    'x': 'P10',
                    'value': 3220
                }
            ]
        }],
        'type': 'column'
    }
};


export const data = [{
		id: 1,
		name: 'Hardware',
	}, {
		id: 2,
		name: 'Software',
	}, {
		id: 3,
		name: 'Manual',
	}, {
		id: 4,
		optimisticStart: Date.UTC(2018, 8, 1),
		optimisticEnd: Date.UTC(2018, 8, 21),
		pessimisticStart: Date.UTC(2018, 8, 1),
		pessimisticEnd: Date.UTC(2018, 8, 29),
		mostLikelyStart: Date.UTC(2018, 8, 1),
		mostLikelyEnd: Date.UTC(2018, 8, 25),
		progressValue: 1,
		parent: 1,
		connectTo: 5,
		name: "Formalize Specs"
	}, {
		id: 5,
		optimisticStart: Date.UTC(2018, 8, 21),
		optimisticEnd: Date.UTC(2018, 9, 15),
		pessimisticStart: Date.UTC(2018, 8, 29),
		pessimisticEnd: Date.UTC(2018, 9, 29),
		mostLikelyStart: Date.UTC(2018, 8, 25),
		mostLikelyEnd: Date.UTC(2018, 9, 22),
		progressValue: 1,
		parent: 1,
		connectTo: 8,
		name: "Design Hardware"
	}, {
		id: 6,
		optimisticStart: Date.UTC(2018, 8, 21),
		optimisticEnd: Date.UTC(2018, 9, 15),
		pessimisticStart: Date.UTC(2018, 8, 29),
		pessimisticEnd: Date.UTC(2018, 9, 25),
		mostLikelyStart: Date.UTC(2018, 8, 25),
		mostLikelyEnd: Date.UTC(2018, 9, 20),
		progressValue: 1,
		parent: 3,
		connectTo: 9,
		name: "Layout Manual"
	}, {
		id: 7,
		optimisticStart: Date.UTC(2018, 8, 21),
		optimisticEnd: Date.UTC(2018, 9, 30),
		pessimisticStart: Date.UTC(2018, 8, 29),
		pessimisticEnd: Date.UTC(2018, 10, 20),
		mostLikelyStart: Date.UTC(2018, 8, 25),
		mostLikelyEnd: Date.UTC(2018, 10, 12),
		progressValue: 1,
		parent: 2,
		connectTo: 12,
		name: "Design Software"
	}, {
		id: 8,
		optimisticStart: Date.UTC(2018, 9, 15),
		optimisticEnd: Date.UTC(2018, 10, 14),
		pessimisticStart: Date.UTC(2018, 9, 29),
		pessimisticEnd: Date.UTC(2018, 11, 2),
		mostLikelyStart: Date.UTC(2018, 9, 22),
		mostLikelyEnd: Date.UTC(2018, 10, 24),
		progressValue: 1,
		parent: 1,
		connectTo: 10,
		name: "Breadboard Hardware"
	}, {
		id: 9,
		optimisticStart: Date.UTC(2018, 9, 15),
		optimisticEnd: Date.UTC(2018, 10, 12),
		pessimisticStart: Date.UTC(2018, 9, 25),
		pessimisticEnd: Date.UTC(2018, 10, 24),
		mostLikelyStart: Date.UTC(2018, 9, 20),
		mostLikelyEnd: Date.UTC(2018, 10, 18),
		parent: 3,
		progressValue: 1,
		connectTo: 13,
		name: "Finish Manual"
	}, {
		id: 10,
		optimisticStart: Date.UTC(2018, 10, 14),
		optimisticEnd: Date.UTC(2018, 11, 12),
		pessimisticStart: Date.UTC(2018, 11, 2),
		pessimisticEnd: Date.UTC(2019, 0, 5),
		mostLikelyStart: Date.UTC(2018, 10, 24),
		mostLikelyEnd: Date.UTC(2018, 11, 26),
		parent: 1,
		progressValue: 1,
		connectTo: 11,
		name: "Test hardware"
	}, {
		id: 11,
		optimisticStart: Date.UTC(2018, 11, 12),
		optimisticEnd: Date.UTC(2019, 0, 3),
		pessimisticStart: Date.UTC(2019, 0, 5),
		pessimisticEnd: Date.UTC(2019, 1, 2),
		mostLikelyStart: Date.UTC(2018, 11, 26),
		mostLikelyEnd: Date.UTC(2019, 0, 19),
		parent: 1,
		progressValue: .6,
		connectTo: 14,
		name: "Release Hardware"
	}, {
		id: 12,
		optimisticStart: Date.UTC(2018, 9, 30),
		optimisticEnd: Date.UTC(2018, 11, 4),
		pessimisticStart: Date.UTC(2018, 10, 20),
		pessimisticEnd: Date.UTC(2019, 0, 1),
		mostLikelyStart: Date.UTC(2018, 10, 13),
		mostLikelyEnd: Date.UTC(2018, 11, 20),
		parent: 2,
		progressValue: .8,
		connectTo: 15,
		name: "Complete Software"
	}, {
		id: 13,
		optimisticStart: Date.UTC(2018, 10, 12),
		optimisticEnd: Date.UTC(2018, 10, 30),
		pessimisticStart: Date.UTC(2018, 10, 23),
		pessimisticEnd: Date.UTC(2018, 11, 13),
		mostLikelyStart: Date.UTC(2018, 10, 18),
		mostLikelyEnd: Date.UTC(2018, 11, 7),
		parent: 3,
		progressValue: .5,
		connectTo: 16,
		name: "Release Manual"
	}, {
		id: 14,
		optimisticStart: Date.UTC(2019, 0, 3),
		optimisticEnd: Date.UTC(2019, 1, 3),
		pessimisticStart: Date.UTC(2019, 1, 2),
		pessimisticEnd: Date.UTC(2019, 2, 6),
		mostLikelyStart: Date.UTC(2019, 0, 19),
		mostLikelyEnd: Date.UTC(2019, 1, 21),
		parent: 1,
		name: "Manufacture Hardware"
	}, {
		id: 15,
		optimisticStart: Date.UTC(2018, 11, 4),
		optimisticEnd: Date.UTC(2018, 11, 26),
		pessimisticStart: Date.UTC(2019, 0, 1),
		pessimisticEnd: Date.UTC(2019, 0, 25),
		mostLikelyStart: Date.UTC(2018, 11, 20),
		mostLikelyEnd: Date.UTC(2019, 0, 12),
		parent: 2,
		name: "Release Software"
	}, {
		id: 16,
		optimisticStart: Date.UTC(2018, 10, 30),
		optimisticEnd: Date.UTC(2018, 11, 15),
		pessimisticStart: Date.UTC(2018, 11, 13),
		pessimisticEnd: Date.UTC(2018, 11, 30),
		mostLikelyStart: Date.UTC(2018, 11, 7),
		mostLikelyEnd: Date.UTC(2018, 11, 23),
		parent: 3,
		name: "Print Manuals"
	}];
